import {Injectable} from '@angular/core';

@Injectable()
export class Codes {
  constructor(){}
}

export class EventCodes {
  public static get USER_LOGIN(): string {return "user:Login";}
  public static get USER_LOGIN_ERROR(): string {return "user:login-error";}
  public static get USER_SIGNUP(): string {return "user:signup";}
  public static get USER_LOGOUT(): string {return "user:logout";}
  public static get DIRECTORY_TYPE_SELECTED(): string {return "directory:type-selected";}
  public static get DIRECTORY_TYPE_PUSH_LIST(): string {return "directory:pus-list-selected";}
  public static get DIRECTORY_TYPE_SELECTED_ALL(): string {return "directory:type-selected-all";}
  public static get DATA_LOADING(): string {return "data:loading";}
  public static get POST_SUBMITTED(): string {return "post:submitted";}
  public static get POST_SUBMITTED_ERROR(): string {return "post:submitted-error";}
  public static get POST_LOADED(): string {return "post:loaded";}
  public static get POPOVER_CHECKBOX_CHANGED(): string {return "popover:checkbox:changed";}
  public static get DYNAMIC_CONTENT_ACTION(): string {return "dyncontent:action:triggered";}
  public static get DONATION_SUBMITTED(): string {return "donation:submitted";}
  public static get APPSETTINGS_LOADING(): string {return "settings:loading";}
  public static get APPSETTINGS_LOADED(): string {return "settings:loaded";}
  public static get PAGE_AFTER_INIT(): string {return "page:afterinit";}
  public static get NAVIGATION_LOADED(): string {return "navigation:loaded";}
}

export class LocalStorageCodes {
  public static get HAS_LOGGED_IN(): string {return "storage:user:has-logged-in";}
  public static get CURRENT_USER(): string {return "storage:user:current-user";}
  public static get LOADED_POSTS(): string {return "storage:post:loaded-posts";}
  public static get APP_SETTINGS(): string {return "storage:app:settings";}
  public static get NAVIGATION(): string {return "navigation:items";}
  public static get RECIPES(): string {return "recipes";}
  public static get RECIPE_CATEGORIES(): string {return "storage:recipe-categories";}
  
  public static get DAM_CATEGORIES(): string {return "storage:dam-categories";}
  public static get DAM_PRODUCTS(): string {return "dam-products";}  


  //Home Page
  public static get PAGE_SECTIONS(): string {return "storage:page-sections";}
  public static get PAGE_WIDGETS(): string {return "storage:page-widgets";}


  //Recipe module
  public static get USER_RECIPES(): string {return "strg:user-recipes";}
  public static get LOCAL_USER_RECIPES_KEY(): string {return "storage:recipe:local-user-recipes_key";}

  public static get SHOPPING_ITEMS(): string {return "strg:shopping-items";}

  //Store
  public static get CURRENT_STORE(): string {return "storage:store:current-store";}
  
}

export class FireBaseObjectNames {
  public static get APP_OPTIONS(): string {return "app-options";}
  public static get NAVIGATION(): string {return "navigation";}
  public static get ORDERS(): string {return "orders";}
  public static get SHOPPING_LIST(): string {return "shopping-list";}

  //Home Page
  public static get PAGE_SECTIONS(): string {return "page-sections";}
  public static get PAGE_WIDGETS(): string {return "page-widgets";}

  //Recipe
  public static get RECIPES(): string {return "recipes";}
  public static get RECIPE_CATEGORIES(): string {return "recipe-categories";}
  public static get USER_RECIPES(): string {return "user-recipes";}

  //Store Locator
  public static get STORELOCATOR(): string {return "stores";}

   //Shopping  List
  public static get SHOPPING_ITEMS(): string {return "shopping-items";}

  //Weekly Ads
  public static get ONLINE_CIRCULAR_WEEKLY_ADS(): string {return "online-circular-weekly-ads";}
  public static get ONLINE_CIRCULARS(): string {return "online-circulars";}  

  //Dynamic Page
  public static get DYNAMIC_PAGE(): string {return "pages";}

  //Products
  public static get DAM_CATEGORIES(): string {return "dam-categories";}
  public static get DAM_PRODUCTS(): string {return "dam-products";}  

}


// WEBPACK FOOTER //
// ./src/core/codes.ts